import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    GL0000205: {}, // 상품상세
    GL0000206: {}, // 통화코드조회
    RBF0406J40: {}, // 예금만기예상금액조회
    RBF0006B00: {}, // 예금신규예비거래
    RBF0006A00: {}, // 예금신규본거래
    //예금신규정보
    depositNewReqInfo: {
      brncoPrdctCd: "", //상품코드
      prdctName: "", //상품명
      cncycd: "", //통화코드
      dpostBal: 0, //신규가입금액
      brncoIntPaymtCyclDstcd: "", //이자지급주기
      autoExpirExtenYn: "", //자동만기연장여부
      expirExtenFormDstcd: "", //만기연장종류
      lnkgAcnoDstcd: "", //자동이체계좌번호
      lnkgAcno: "", //연결계좌번호
      lnkgAcnoAls: "", //연결계좌명
      lnkgAcnCncycd: "", //연결계좌통화코드
      indpCnpr: {
        ctrcTrmUnitDstic: "", //가입기간구분
        ctrcTrmCnt: "", //가입기간
      },
      accountingCommon: {
        cupldAcno: "", //출금계좌번호
        cupldAcnoAls: "", //출금계좌명
        fxCncycd: "", //출금계좌통화코드
      },
      uuidPwd: "",
      uuidPwdCnfrm: "",
      uuidCupldPwd: "",
      isStpulCfm: false, //약관동의여부
      isMobile: 0, //모바일여부 (1: 스타뱅킹)
    },
    //가입제한사항 체크리스트
    check1: "",
    check2: "",
    check3: "",
    check4: "",
    check5: "",
    selectoperGroupCd: "",
    eKycParam: {}, //생체정보 등록 데이터
    depositNewReqData: {}, //예금신규 데이터
  };
};

const depositNewReq = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    // 상품상세
    getGL0000205: state => {
      return state.GL0000205;
    },
    // 예금신규 예비거래
    getRBF0006B00: state => {
      return state.RBF0006B00;
    },
    // 예금신규 본거래
    getRBF0006A00: state => {
      return state.RBF0006A00;
    },
    // 예금신규 가입정보
    getDepositNewReqInfo: state => {
      return state.depositNewReqInfo;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    // 상품상세 초기화
    setGL0000205_init: state => {
      state.GL0000205 = getDefaultState().GL0000205;
    },
    // 상품가입통화코드목록 초기화
    setGL0000206_init: state => {
      state.GL0000206 = getDefaultState().GL0000206;
    },
    // 예금만기예상금액 초기화
    setRBF0406J40_init: state => {
      state.RBF0406J40 = getDefaultState().RBF0406J40;
    },
    // 예금신규 예비거래 초기화
    setRBF0006B00_init: state => {
      state.RBF0006B00 = getDefaultState().RBF0006B00;
    },
    // 예금신규 본거래 초기화
    setRBF0006A00_init: state => {
      state.RBF0006A00 = getDefaultState().RBF0006A00;
    },
    // 예금신규 가입정보 초기화
    setDepositNewReqInfo_init: state => {
      state.depositNewReqInfo = getDefaultState().depositNewReqInfo;
    },
    // 상품상세
    setGL0000205: (state, payload) => {
      state.GL0000205 = payload;
    },
    // 예금신규 예비거래
    setRBF0006B00: (state, payload) => {
      state.RBF0006B00 = payload;
    },
    // 예금신규 본거래
    setRBF0006A00: (state, payload) => {
      state.RBF0006A00 = payload;
    },
    // 예금신규 가입정보
    setDepositNewReqInfo: (state, payload) => {
      state.depositNewReqInfo = payload;
    },
  },
  actions: {
    // 상품상세 초기화
    ACT_setGL0000205_init: context => {
      context.commit("setGL0000205_init");
    },
    // 상품가입통화코드목록 초기화
    ACT_setGL0000206_init: context => {
      context.commit("setGL0000206_init");
    },
    // 예금만기예상금액 초기화
    ACT_setRBF0406J40_init: context => {
      context.commit("setRBF0406J40_init");
    },
    // 예금신규 예비거래 초기화
    ACT_setRBF0006B00_init: context => {
      context.commit("setRBF0006B00_init");
    },
    // 예금신규 본거래 초기화
    ACT_setRBF0006A00_init: context => {
      context.commit("setRBF0006A00_init");
    },
    // 예금신규 가입정보 초기화
    ACT_setDepositNewReqInfo_init: context => {
      context.commit("setDepositNewReqInfo_init");
    },
    // 상품상세
    ACT_setGL0000205: (context, payload) => {
      context.commit("setGL0000205", payload);
    },
    // 예금신규 예비거래
    ACT_setRBF0006B00: (context, payload) => {
      context.commit("setRBF0006B00", payload);
    },
    // 예금신규 본거래
    ACT_setRBF0006A00: (context, payload) => {
      context.commit("setRBF0006A00", payload);
    },
    // 예금신규 가입정보
    ACT_setDepositNewReqInfo: (context, payload) => {
      context.commit("setDepositNewReqInfo", payload);
    },
  },
};

export default depositNewReq;
